import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

dayjs.extend(relativeTime);
dayjs.extend(utc);

export const formatMessageTime = (date?: string, format?: string): string => {
  if (!date || date.trim() === "") {
    return "";
  }

  const localDate = dayjs.utc(date).local();

  if (!localDate.isValid()) {
    return "";
  }

  return format ? localDate.format(format) : localDate.fromNow();
};
